const $ = require('jquery');
require('slick-carousel');

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize load', () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

$(function () {
  fixFocus();
  videoPlayer();
  initProductSlider();
});

$(window).on('load', function () {
});

function fixFocus() {
  $('body').on('keydown', function (e) {
    var keyCode = e.key || e.code;
    if (keyCode == 'Tab') {
      $('body').addClass('tab-pressed');
    }
  });
}

function videoPlayer() {
  $('video').parent().on('click', function () {
    if ($(this).children("video").get(0).paused) {
      $(this).children("video").get(0).play(); $(this).children(".playpause").fadeOut();
    } else {
      $(this).children("video").get(0).pause();
      $(this).children(".playpause").fadeIn();
    }
  });
}

function initProductSlider() {
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.2002" cy="20" r="20" transform="rotate(90 20.2002 20)" fill="#E2E2EA"/><path d="M14.5182 22.2727L20.2 16.5909L25.8818 22.2727" stroke="#212121" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-prev"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.2002" cy="20.4" r="20" transform="rotate(-90 20.2002 20.4)" fill="#E2E2EA"/><g clip-path="url(#clip0_277_32078)"><path d="M25.8822 18.1273L20.2004 23.8091L14.5186 18.1273" stroke="#212121" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></g><defs><clipPath id="clip0_277_32078"><rect width="18.1818" height="18.1818" fill="white" transform="matrix(0 -1 1 0 11.1094 29.4909)"/></clipPath></defs></svg></button>',
    
    responsive: [
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }
    ]
  });
}